export default class ProductGallery {
  constructor() {
    this.galleryElement = document.getElementById("product-gallery")
    this.productImages = this.galleryElement.getElementsByClassName("gallery-image")
    this.thumbnails = this.galleryElement.getElementsByClassName("gallery-thumbnail")

    for (let thumbnail of this.thumbnails) {
      thumbnail.addEventListener("click", this.handleClickThumbnail.bind(this))
    }

    document.addEventListener("variantSelected", this.handleVariantSelected.bind(this))
  }

  show(imageId) {
    const imageElement = this.galleryElement.querySelector(`.gallery-image[data-image-id="${imageId}"]`)

    if (!imageElement) return

    for (let productImage of this.productImages) {
      productImage.classList.add("hide")

      if (productImage.dataset.imageId === imageId) {
        productImage.classList.remove("hide")
      }
    }
  }

  handleVariantSelected(event) {
    this.show(event.detail)
  }

  handleClickThumbnail(event) {
    const imageId = event.target.parentElement.dataset.imageId

    this.show(imageId)
  }
}
